const addToCart = () => {
  const stickyAddToCartBodyClass = 'ab-test-sticky-add-to-cart';
  const purchaseOptions = document.querySelectorAll('.purchase-option');
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  const stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]');
  const stickyOptionCopy = stickyAddToCart?.querySelector('[data-sticky-option-copy]');
  const stickyButtonText = stickyAddToCart?.querySelector('[data-sticky-button-text]');
  const primaryAddToCartButton = document.querySelector('.add-to-cart-button--primary-trigger');
  let stickyListenersBound = false;

  if (!addToCartButtons.length) {
    return;
  }

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const isStickyAddToCartEnabled = () => document.body.classList.contains(stickyAddToCartBodyClass);

  const updateStickyBarContent = () => {
    if (!isStickyAddToCartEnabled() || !stickyAddToCart) {
      return;
    }

    const selectedOption = document.querySelector('.purchase-option.purchase-option--selected');
    if (!selectedOption) {
      return;
    }

    const selectedSellingPlanId = selectedOption.getAttribute('data-selling-plan-id');
    const isSubscription = selectedSellingPlanId && selectedSellingPlanId !== 'null';
    const selectedPrice = normalizeText(selectedOption.querySelector('.price strong')?.textContent);
    const deliveryDate = normalizeText(selectedOption.querySelector('.delivery-date')?.textContent);
    const onetimeSubtitle = stickyAddToCart.dataset.onetimeSubtitle || 'One-time';
    const ctaSubscription = stickyAddToCart.dataset.ctaSubscription || 'Add Subscription to Cart';
    const ctaOnetime = stickyAddToCart.dataset.ctaOnetime || 'Add to Cart';

    if (stickyOptionCopy) {
      stickyOptionCopy.textContent = isSubscription ? deliveryDate : onetimeSubtitle;
    }

    if (stickyButtonText) {
      stickyButtonText.textContent = `${isSubscription ? ctaSubscription : ctaOnetime} | ${selectedPrice}`;
    }
  };

  const updateStickyBarVisibility = () => {
    if (!isStickyAddToCartEnabled() || !stickyAddToCart || !primaryAddToCartButton) {
      if (stickyAddToCart) {
        stickyAddToCart.classList.remove('is-visible');
        stickyAddToCart.setAttribute('aria-hidden', 'true');
      }

      return;
    }

    const primaryButtonRect = primaryAddToCartButton.getBoundingClientRect();
    const shouldShowStickyBar = primaryButtonRect.bottom < 0;

    stickyAddToCart.classList.toggle('is-visible', shouldShowStickyBar);
    stickyAddToCart.setAttribute('aria-hidden', shouldShowStickyBar ? 'false' : 'true');
  };

  const updateSellingPlanOnButtons = (sellingPlanId) => {
    addToCartButtons.forEach((button) => {
      button.setAttribute('data-selling-plan-id', sellingPlanId || 'null');
    });
  };

  const bindStickyBarListeners = () => {
    if (stickyListenersBound || !stickyAddToCart || !primaryAddToCartButton) {
      return;
    }

    window.addEventListener('scroll', updateStickyBarVisibility, { passive: true });
    window.addEventListener('resize', updateStickyBarVisibility);
    stickyListenersBound = true;
  };

  const syncStickyBarState = () => {
    if (!stickyAddToCart) {
      return;
    }

    if (!isStickyAddToCartEnabled()) {
      stickyAddToCart.classList.remove('is-visible');
      stickyAddToCart.setAttribute('aria-hidden', 'true');
      return;
    }

    bindStickyBarListeners();
    updateStickyBarContent();
    updateStickyBarVisibility();
  };

  const initialSelectedOption = document.querySelector('.purchase-option.purchase-option--selected');
  if (initialSelectedOption) {
    const initialSellingPlanId = initialSelectedOption.getAttribute('data-selling-plan-id');
    updateSellingPlanOnButtons(initialSellingPlanId);
  }

  syncStickyBarState();

  purchaseOptions.forEach(option => {
    option.addEventListener('click', function () {
      purchaseOptions.forEach(opt => opt.classList.remove('purchase-option--selected'));
      this.classList.add('purchase-option--selected');

      const sellingPlanId = this.getAttribute('data-selling-plan-id');
      updateSellingPlanOnButtons(sellingPlanId);
      updateStickyBarContent();
    });
  });

  if (stickyAddToCart && document.body) {
    const bodyClassObserver = new MutationObserver(() => {
      syncStickyBarState();
    });

    bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.setTimeout(syncStickyBarState, 250);
    window.setTimeout(syncStickyBarState, 1000);
    window.setTimeout(syncStickyBarState, 2500);
  }

  addToCartButtons.forEach((addToCartButton) => {
    addToCartButton.addEventListener('click', async function () {
      const buttonText = this.querySelector('.button-text');
      const loadingSpinner = this.querySelector('.loading-overlay__spinner');
      const variantId = this.getAttribute('data-variant-id');
      const sellingPlanId = this.getAttribute('data-selling-plan-id');
      const addonVariantId = this.getAttribute('data-addon-variant-id');
      const addonVariantIds = (this.getAttribute('data-addon-variant-ids') || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);

      if (!variantId) {
        console.error('Add to cart failed: missing variant id');
        return;
      }

      if (buttonText) {
        buttonText.style.display = 'none';
      }
      if (loadingSpinner) {
        loadingSpinner.classList.remove('hidden');
      }
      this.disabled = true;

      try {
        const primaryItem = {
          id: variantId,
          quantity: 1
        };
        const itemsToAdd = [primaryItem];

        if (sellingPlanId && sellingPlanId !== 'null') {
          primaryItem.selling_plan = sellingPlanId;
        }

        if (addonVariantId) {
          const addonIdsToCheck = addonVariantIds.length ? addonVariantIds : [addonVariantId];
          const addonAlreadyInCart = await areAnyVariantsInCart(addonIdsToCheck);

          if (!addonAlreadyInCart) {
            itemsToAdd.push({
              id: addonVariantId,
              quantity: 1
            });
          }
        }

        await addItemsToCartWithDrawer(itemsToAdd);

        await getCartTotal();
      } catch (err) {
        console.error('Cart update failed:', err);
      } finally {
        if (buttonText) {
          buttonText.style.display = 'block';
        }
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
        this.disabled = false;
      }
    });
  });

  async function addItemsToCartWithDrawer(items) {
    const requestItems = (items || [])
      .filter((item) => item && item.id)
      .map((item) => {
        const requestItem = {
          id: item.id,
          quantity: item.quantity || 1
        };

        if (
          typeof item.selling_plan !== 'undefined'
          && item.selling_plan !== null
          && item.selling_plan !== 'null'
        ) {
          requestItem.selling_plan = item.selling_plan;
        }

        return requestItem;
      });

    if (!requestItems.length) {
      throw new Error('Add to cart failed: missing line items');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: requestItems })
    });

    if (!response.ok) {
      let errorMessage = 'Add to cart failed';
      try {
        const errorData = await response.json();
        if (errorData && errorData.description) {
          errorMessage = errorData.description;
        }
      } catch (e) {
        errorMessage = 'Add to cart failed';
      }

      throw new Error(errorMessage);
    }

    await response.json();

    const inlineCart = document.querySelector('.inline-cart');
    const inlineCartPageOverlay = document.querySelector('.inline-cart__page-overlay');

    if (inlineCart) {
      inlineCart.classList.add('active');
    }
    if (inlineCartPageOverlay) {
      inlineCartPageOverlay.classList.add('active');
    }
    document.body.classList.add('body--no-scroll');
  }

  async function areAnyVariantsInCart(variantIds) {
    const normalizedVariantIds = Array.from(
      new Set((variantIds || []).map((variantId) => String(variantId).trim()).filter(Boolean))
    );

    if (!normalizedVariantIds.length) {
      return false;
    }

    try {
      const cart = await fetchCartData();
      if (!cart || !Array.isArray(cart.items)) {
        return false;
      }

      return cart.items.some((item) => normalizedVariantIds.includes(String(item.variant_id)));
    } catch (err) {
      console.error('Error checking cart for addon variant:', err);
      return false;
    }
  }

  async function fetchCartData() {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    return response.json();
  }

  async function getCartTotal() {
    try {
      const cart = await fetchCartData();


      const freeShippingThreshold = window.cartData.freeShippingThreshold;
      const totalPriceInCents = cart.total_price;
      const totalPriceFormatted = (totalPriceInCents / 100).toFixed(2);

      if (totalPriceFormatted >= freeShippingThreshold) {
        if (document.querySelector('.shipping-info__header--free')) {
          document.querySelector('.shipping-info__header--free').style.display = 'block';
        }
        if (document.querySelector('.shipping-info__header')) {
          document.querySelector('.shipping-info__header').style.display = 'none';
        }
      } else {
        if (document.querySelector('.shipping-info__header')) {
          document.querySelector('.shipping-info__header').style.display = 'block';
        }
        if (document.querySelector('.shipping-info__header--free')) {
          document.querySelector('.shipping-info__header--free').style.display = 'none';
        }
      }

      return totalPriceFormatted;
    } catch (err) {
      console.error('Error fetching cart total:', err);
      return null;
    }
  }


}

export default addToCart;